// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"bace012a","584":"a6bf1441"}[chunkId] + ".chunk.js";
};